<template>
    <tr class="row">
        <td>{{number}}</td>
        <td>{{desc}}</td>
        <td>{{quota}}</td>
        <td class="button-cell">{{usage}} 
            <button class="unstyled-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20" width="20" fill="#051C2E">
                    <path d="M8.025 21.65 6.6 20.225 14.825 12 6.6 3.775 8.025 2.35l9.65 9.65Z"/>
                </svg>
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProjectItem",
    props: {
        number: String,
        desc: String,
        quota: Number,
        usage: Number
    }
}
</script>

<style scoped>
.row {
    cursor: pointer;
}

.button-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.unstyled-button {
    padding: 0;
}

</style>